import React from "react";
import { SkillModel } from "../../api/models/RecitationSkillsModel";
import ShowIf from "../show-if/ShowIf";
import Skill from "./Skill";

type SkillsListProps = {
  skills: SkillModel[];
  onSkillClick: (skill: SkillModel) => void;
  isEditable?: boolean;
  colorPrimary?: boolean;
};
export default function SkillsList(props: SkillsListProps) {
  const { skills, onSkillClick, isEditable, colorPrimary } = props;
  if (!skills.length) return null;

  return (
    <ul className="w-full">
      {skills.map((skill) => (
        <Skill
          key={skill.hashedPath}
          skill={skill}
          onToggle={onSkillClick}
          isEditable={isEditable}
          colorPrimary={colorPrimary}
        >
          {!!skill.subSkills?.length && (
            <SkillsList
              skills={skill.subSkills!}
              onSkillClick={onSkillClick}
              isEditable={isEditable}
              colorPrimary={colorPrimary}
            />
          )}
        </Skill>
      ))}
    </ul>
  );
}
